<template>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/"></router-link><router-link to="/projects"> Daily Infrastructure Work Around the County</router-link></h2>
            <div id="blurb">
              <p>
                  Find infrastructure maintenance and repairs happening around the County. Don't see work represented on the map? It may be a Washington Gas, Dominion Power, VDOT, APS or private ownership project.
                  Or check our <a href="https://my.arlingtonva.us/projects"> Projects pages</a>.
              </p>
              <br/>
            </div>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <div class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                </div>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <div class="filter-header" @click="filtersToggle" v-show="!isMobile" >
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                                <div style="clear: both"></div>
                            </span>
                        </div>
                        <div class="filterList" v-show="filtersExpanded || mobileMenu">

                        </div>
                    </div>

                    <h3>Zoom to Location</h3>
                    <div class="filter-container">
                        <button @click="getCurrentLocation" class="filter-header">Your Current Location</button>
                    </div>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete ref="autocomplete" @place_changed="placeChanged"></gmap-autocomplete>
                    </div>
                    <div class="filter-container">
                        <label for="civicAssociation">Civic Association</label>
                        <br />
                        <div>
                            <select id="civicAssociation" v-model="civicAssocationsSelected">
                                <option value="">Select a civic association</option>
                                <option v-for="ca in civicAssociations" :key="ca.OBJECTID" :value="ca">{{ca.LABEL}}</option>
                            </select>
                        </div>
                        <span v-show="civicAssociationFailure">Unable to load Civic Assocations.</span>
                    </div>
                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window">
                <div style="position: relative; top: 0">
                  <h3 class="toggle-bar">
                    <a :class="showMap === true ? 'toggle-link' : 'toggle-link active'" @click="showMap = true">Map</a>
                    <a :class="showMap === false ? 'toggle-link' : 'toggle-link active'" @click="showMap = false" id="list-link">List</a>
                  </h3>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    >

                    <!-- Project Shapes -->
                    <div v-for="project in filteredProjects" :key="project.id">
                      <div v-for="shape in project.shapes" :key="project.id + '_' + shape">
                        <gmap-polygon v-if="shape.shape === 'polygon'" :paths="shape.coordinates" :options="shapeOptions" @click="(e) => shapeClick(project, e)"></gmap-polygon>
                        <gmap-polyline v-if="shape.shape === 'polyline'" :path="shape.coordinates" :options="shapeOptions" @click="(e) => shapeClick(project, e)"></gmap-polyline>
                        <gmap-circle v-if="shape.shape === 'marker'" :key="shape.id" :center="shape.coordinates" :options="shapeOptions" :radius="32" @click="(e) => shapeClick(project, e)"></gmap-circle>
                      </div>
                    </div>
                    <!-- Common Info Window -->
                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <div class="info-window">
                            <b>
                              <a v-if="!selectedItem.hideUrl" :href="selectedItem.url" target="_blank" v-html="selectedItem.title">Website</a>
                              <span v-if="selectedItem.hideUrl" v-html="selectedItem.title">Website</span>
                            </b>
                            <div v-if="selectedItem.content" v-html="selectedItem.content"></div>
                            <div v-if="selectedItem.buildingPermitList">
                              <router-link :to="{ name: 'Project', params: { id: selectedItem.id }}">Permits</router-link>
                            </div>
                        </div>
                    </gmap-info-window>

                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="project in filteredProjects" :key="project.id" class="project">
                    <h3>
                      <a v-if="project.hideUrl" v-html="project.title"></a>
                      <a v-if="!project.hideUrl" :href="project.url" v-html="project.title"></a>
                    </h3>
                    <p v-if="project.content" v-html="project.content" class="no-vertical-margin"></p>
                    <p v-if="project.buildingPermitList" class="no-vertical-margin">
                      <router-link :to="{ name: 'Project', params: { id: project.id }}">Permits</router-link>
                    </p>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import R from 'ramda';
import geolib from 'geolib';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters, mapActions } from 'vuex';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
})

export default {
  name: 'projects',
  props: ['queryStatus', 'querySubStatus', 'queryProjectType'],
  data () {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      statuses: [
        {
          value: 'Proposed',
          label: 'Proposed',
          subStatuses: [
            { value: 'No Status', label: 'No Status' },
            { value: 'Preliminary Proposal', label: 'Preliminary Proposal' },
            { value: 'Under Review', label: 'Under Review' },
            { value: 'Final Submittal', label: 'Final Submittal' },
            { value: 'On Hold', label: 'On Hold' },
            { value: 'Expired', label: 'Expired' }
          ]
        },
        {
          value: 'Approved',
          label: 'Approved',
          subStatuses: [
            { value: 'Approved', label: 'Approved' },
            { value: 'Planned', label: 'Planned' },
            { value: 'In Design', label: 'In Design' },
            { value: 'Procurement', label: 'Procurement' },
            { value: 'Out to Bid', label: 'Out to Bid' }
          ]
        },
        { value: 'Construction', label: 'Construction', subStatuses: [] },
        { value: 'Complete', label: 'Complete', subStatuses: [] }
      ],
      statusesSelected: [],
      subStatusesSelected: [],
      projectTypes: [
        { value: 'Daily Work', label: 'Daily Work', tooltip: 'Includes County street projects, such as paving and sewer work happening today. Delayed or cancelled projects may still appear on map.' },
        { value: 'Environment', label: 'Environment', tooltip: 'Includes stormwater, watershed and streams projects.' },
        { value: 'County Facilities', label: 'Facilities', tooltip: 'Includes County facility projects.' },
        { value: 'Neighborhood Conservation', label: 'Neighborhood Conservation', tooltip: 'Identifies and provides funding for a variety of neighborhood improvements.' },
        { value: 'Parks', label: 'Parks', tooltip: 'Includes parks, fields, courts, playgrounds, shelters and trails.' },
        { value: 'Transportation', label: 'Transportation', tooltip: 'Includes bike, pedestrian, street and transit projects.' },
        { value: 'Water &amp; Utilities', label: 'Water &amp; Utilities', tooltip: 'Includes water, utility undergrounding, sanitary sewer, communications/cable, stormwater, watershed and streams projects.' },
        { value: 'Site Plan Project', label: 'Private Development', tooltip: 'Includes submitted, approved, under construction and recently completed site plan projects.' }
      ],
      projectTypesSelected: ['Daily Work'],
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: ''
    }
  },
  computed: {
    ...mapGetters(['projects', 'civicAssociations']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      if (this.civicAssocationsSelected) {
        const civicCenter = geolib.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }

      return this.center;
    },
    filteredProjects: function () {
      var sortByTitle = R.sortBy(R.compose(R.toLower, R.prop('title')));
      if (this.projectTypesSelected.length === 0 && this.statusesSelected.length === 0) {
        return R.compose(sortByTitle, R.filter(f => f.title))(this.projects);
      }

      let temp = this.projects;

      if (this.statusesSelected.length > 0) {
        temp = temp.filter((val, index) => {
          return R.contains(val.status, this.statusesSelected);
        });

        if (this.subStatusesSelected.length > 0) {
          temp = temp.filter((val, inex) => {
            return R.contains(val.subStatus, this.subStatusesSelected);
          });
        }
      }

      if (this.projectTypesSelected.length > 0) {
        const projectTypesSelected = this.projectTypesSelected;
        temp = temp.filter((val, index) => {
          const types = R.map(R.prop('name'), val.projects);
          const intersection = R.intersection(types, projectTypesSelected);
          return intersection.length > 0;
        });
      }
      return sortByTitle(temp);
    },
    filteredStatusCount: function () {
      let temp = this.projects;

      // filter by only type:
      if (this.projectTypesSelected.length > 0) {
        const projectTypesSelected = this.projectTypesSelected;
        temp = temp.filter((val, index) => {
          const types = R.map(R.prop('name'), val.projects);
          const intersection = R.intersection(types, projectTypesSelected);
          return intersection.length > 0;
        });
      }

      return R.countBy(R.prop('status'))(temp);
    },
    filteredSubStatusCount: function () {
      let temp = this.projects;

      // filter by only type:
      if (this.projectTypesSelected.length > 0) {
        const projectTypesSelected = this.projectTypesSelected;
        temp = temp.filter((val, index) => {
          const types = R.map(R.prop('name'), val.projects);
          const intersection = R.intersection(types, projectTypesSelected);
          return intersection.length > 0;
        });
      }

      return R.countBy(R.prop('subStatus'))(temp);
    },
    filteredTypeCount: function () {
      let temp = this.projects;

      if (this.statusesSelected.length > 0) {
        temp = temp.filter((val, index) => {
          return R.contains(val.status, this.statusesSelected);
        });

        if (this.subStatusesSelected.length > 0) {
          temp = temp.filter((val, inex) => {
            return R.contains(val.subStatus, this.subStatusesSelected);
          });
        }
      }

      const flat = R.compose(R.flatten, R.map(R.prop('projects')))(temp);
      const countType = R.countBy(R.prop('name'))(flat);
      return countType;
    }
  },
  mounted: function () {
    this.loadCivicAssociations();
    this.loadProjects();

    this.isMobile = window.innerWidth < 600;

    if (this.queryStatus) {
      const split = this.queryStatus.split(',');
      this.statusesSelected = split;
      this.filtersExpanded = true;
    }

    if (this.querySubStatus) {
      const statusSplit = this.querySubStatus.split(',');
      this.subStatusesSelected = statusSplit;
      this.filtersExpanded = true;
    }

    if (this.queryProjectType) {
      const projSplit = this.queryProjectType.split(',');
      console.log('Projects', projSplit);
      var joined = R.innerJoin((record, label) => record.label === label, this.projectTypes);
      var values = R.map(R.prop('value'));

      this.projectTypesSelected = R.compose(values, joined)(projSplit);
      this.filtersExpanded = true;
    }
  },
  watch: {
    statusesSelected () {
      this.infoWindowCheck();
    },
    projectTypesSelected () {
      this.infoWindowCheck();
    }
  },
  methods: {
    ...mapActions(['loadProjects', 'loadCivicAssociations']),
    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    clearAll () {
      this.subStatusesSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
  color: #e87c1a;
    }

    .active {
      color: #015cb9;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// Projects.vue?4eb6292f